import { store } from "../../redux/store";
import { apiPost } from "../api";
import { getdeviceId } from "../auth";
import { refreshAdminTokens } from "../../redux/adminSlice";

/**
 * تقوم بطلب accessToken جديد باستخدام refreshToken
 * @returns accessToken الجديد أو null إذا فشل
 */
export const refreshAccessTokenAdmin = async (): Promise<string | null> => {
  const state = store.getState();
  const refreshToken = state.admin.refreshToken;
  const deviceId = getdeviceId();

  console.log(refreshToken);
  console.log({ deviceId });

  if (!refreshToken) return null;

  try {
    // استدعاء API لتحديث accessToken
    const response = (await apiPost("admin/refresh-token", {
      refreshToken,
      deviceId,
    })) as { accessToken: string; refreshToken: string };
    // حفظ accessToken الجديد في Redux

    console.log(response);
    store.dispatch(
      refreshAdminTokens({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
      })
    );

    return response.accessToken;
  } catch (err) {
    console.error("Failed to refresh access token", err);
    // store.dispatch(logoutOwner()); // إذا انتهت صلاحية refreshToken → logout
    return null;
  }
};
